import { notificationShow } from '@frontend/common';

/*
*
* Middleware
*
*/
export const apiMessages = store => next => action => { // eslint-disable-line
  if (action.error) return; // ignore extra actions with error set as true

  const { payload } = action;

  if (payload) {
    const errorMessages = [];
    const infoMessages = [];
    const warningMessages = [];

    // Handler for API error codes
    if (payload.status >= 299 && payload.status < 400) { // Redirection
      errorMessages.push('A temporary redirect was issued by the server.');
      window.location.href = '/';
    }
    else if (payload.status === 400) { // payload.data may be an array of messages.
      if (payload.data && payload.data.length > 0) {
        payload.data.forEach(msg => {
          switch (msg.MessageType) {
            case 0: infoMessages.push(msg.Message); break;
            case 1: warningMessages.push(msg.Message); break;
            case 2: errorMessages.push(msg.Message); break;
            default: break;
          }
        });
      }
      else {
        errorMessages.push('A bad request. No messages were provided. Status: 400.');
      }
    }
    else if (payload.status === 404) {
      errorMessages.push('Not found');
    }
    else if (payload.status > 400 && payload.status < 600) {
      errorMessages.push('There was an issue communicating with the server. Please try again later, or contact my529 if you continue to experience this issue.');
    }

    if (errorMessages.length > 0) {
      errorMessages.forEach(error => store.dispatch(notificationShow(error, 'error')));
      const updatedAction = action;
      updatedAction.type = `${action.type}_ERRORS`;
      next(updatedAction);
      return Promise.reject(action);
    }

    if (warningMessages.length > 0) {
      warningMessages.forEach(warning => store.dispatch(notificationShow(warning, 'warning')));
    }

    if (infoMessages.length > 0) {
      infoMessages.forEach(info => store.dispatch(notificationShow(info, 'warning')));
    }

    return next(action);
  }

  // Non-async actions
  else {
    return next(action);
  }
};
